import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import GenericEntityCreator from '../../components/Common/GenericEntityCreator';

const CreateTrade: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = (createdEntity: any) => {
    console.log('Trade created:', createdEntity);
    navigate('/trades');
  };

  const handleCancel = () => {
    navigate('/trades');
  };

  return (
    <Box>
      {/* Breadcrumbs */}
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{ mb: 3 }}
      >
        <Link
          color="inherit"
          href="/trades"
          onClick={(e) => {
            e.preventDefault();
            navigate('/trades');
          }}
        >
          Trade Management
        </Link>
        <Typography color="text.primary">Create Trade</Typography>
      </Breadcrumbs>

      {/* Generic Entity Creator */}
      <GenericEntityCreator
        entityType="trade"
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </Box>
  );
};

export default CreateTrade;

